import React, { useEffect, useState, useCallback } from "react";
import { TextField, Autocomplete, Chip } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import { api } from "../../../utils/api";
import { BASE_URL } from "../../../constants";
import "./chats.css";
import SimpleReactValidator from "simple-react-validator";

const ErrorPopup = ({ message, onClose }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (message) {
      setVisible(true);
      const timer = setTimeout(() => handleClose(), 5000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => onClose(), 300);
  };

  if (!message || !visible) return null;

  return (
    <div style={overlayStyle}>
      <div style={popupStyle} className="fadeIn">
        <div style={iconContainer}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="#e53935"
            width="36"
            height="36"
          >
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 
            10 10 10-4.48 10-10S17.52 2 12 2zm.88 13.47c0 
            .49-.39.88-.88.88s-.88-.39-.88-.88v-1.76c0-.49.39-.88.88-.88s.88.39.88.88v1.76zm0-4.7c0 
            .49-.39.88-.88.88s-.88-.39-.88-.88V7.71c0-.49.39-.88.88-.88s.88.39.88.88v3.06z"
            />
          </svg>
        </div>
        <div style={{ fontSize: "15px", color: "#333", textAlign: "center" }}>
          {message}
        </div>
        <button style={buttonStyle} onClick={handleClose}>
          OK
        </button>

        <style>
          {`
            @keyframes fadeIn {
              from { opacity: 0; transform: scale(0.9); }
              to { opacity: 1; transform: scale(1); }
            }
            .fadeIn {
              animation: fadeIn 0.3s ease-out;
            }
          `}
        </style>
      </div>
    </div>
  );
};

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.4)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
};

const popupStyle = {
  background: "#fff",
  padding: "24px 28px",
  borderRadius: "12px",
  boxShadow: "0 6px 20px rgba(0, 0, 0, 0.1)",
  maxWidth: "360px",
  width: "90%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "16px",
};

const iconContainer = {
  background: "#fdecea",
  borderRadius: "50%",
  padding: "12px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const buttonStyle = {
  backgroundColor: "#e53935",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  padding: "8px 20px",
  fontWeight: "bold",
  cursor: "pointer",
  marginTop: "4px",
  transition: "0.2s",
};
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: 4,
  borderRadius: "8px",
};

const AddCollobrationModal = ({
  open,
  onClose,
  onSave,
  formData,
  setFormData,
  groupId,
  isEditModel,
  onEdit,
  apiError,
  clearApiError,
}) => {
  const [members, setMembers] = useState([]);
  const [memberSearch, setMemberSearch] = useState("");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(0);
  const [validator, setValidator] = useState(
    () =>
      new SimpleReactValidator({
        messages: {
          required: ":attribute field is required",
        },
        element: (message) => (
          <div style={{ color: "red", fontSize: "12px" }}>{message}</div>
        ),
      })
  );

  // const fetchMembers = useCallback(
  //   async (searchTerm) => {
  //     if (searchTerm.length < 3) {
  //       setOptions([]);
  //       return;
  //     }
  //     try {
  //       setLoading(true);
  //       const res = await api.get(
  //         `${BASE_URL}/searchGroupMembers/?group_id=${groupId}&searchquery=${encodeURIComponent(
  //           searchTerm
  //         )}`
  //       );
  //       const members = res.data || [];
  //       const filtered = members.filter(
  //         (m) => !formData.members?.some((sel) => sel.id === m.id)
  //       );

  //       setOptions(filtered);
  //     } catch (error) {
  //       console.error("Error fetching members:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   },
  //   [groupId, formData.members]
  // );
  const fetchMembers = useCallback(
    async (searchTerm) => {
      if (searchTerm.length < 3) {
        setOptions([]);
        return;
      }
      try {
        setLoading(true);
        const res = await api.get(
          `${BASE_URL}/searchGroupMembers/?group_id=${groupId}&searchquery=${encodeURIComponent(
            searchTerm
          )}`
        );
        const members = res.data || [];
        const filtered = members.filter(
          (m) => !formData.members?.some((sel) => sel.id === m.id)
        );

        setOptions(filtered);
      } catch (error) {
        console.error("Error fetching members:", error);
      } finally {
        setLoading(false);
      }
    },
    [groupId, formData.members]
  );

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (memberSearch.length >= 3) {
        fetchMembers(memberSearch);
      }
    }, 400);
    return () => clearTimeout(delayDebounce);
  }, [memberSearch, fetchMembers]);

  useEffect(() => {
    if (!open) {
      setMembers([]);
      setOptions([]);
      setMemberSearch("");
      setFormData({ name: "", members: [] });
    } else {
      setValidator(
        new SimpleReactValidator({
          messages: {
            required: ":attribute field is required",
          },
          element: (message) => (
            <div style={{ color: "red", fontSize: "12px" }}>{message}</div>
          ),
        })
      );
      setForceUpdate((prev) => prev + 1);
    }
  }, [open, setFormData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // const handleMemberChange = (event, newValue) => {
  //   setMembers(newValue);
  //   setFormData({ ...formData, members: newValue });
  // };
    const handleMemberChange = (event, newValue) => {
    setMembers(newValue);
    setFormData({ ...formData, members: newValue });
    setOptions((prev) =>
      prev.filter((opt) => !newValue.some((sel) => sel.id === opt.id))
    );
  };

  const handleSave = () => {
     if (formData.name.length > 100) {
      setForceUpdate((prev) => prev + 1);
      return;
    }
    if (validator.allValid()) {
      onSave(formData);
    } else {
      validator.showMessages();
      setForceUpdate((prev) => prev + 1);
    }
  };

  const handleEdit = () => {
     if (formData.name.length > 100) {
      setForceUpdate((prev) => prev + 1);
      return;
    }
    if (validator.allValid()) {
      onEdit(formData);
    } else {
      validator.showMessages();
      setForceUpdate((prev) => prev + 1);
    }
  };

  return (
    <>
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <CloseIcon
            sx={{ cursor: "pointer", color: "text.secondary" }}
            onClick={onClose}
          />
        </Box>

        <Typography variant="h6" sx={{ mb: 3, fontWeight: "bold" }}>
          Create New Collaboration
        </Typography>

        {/* Group Name with validation */}
        <Box sx={{ mb: 2 }}>
            <TextField
              name="name"
              label="Collaboration Name"
              placeholder="Enter collaboration name"
              fullWidth
              margin="normal"
              value={formData.name}
              onChange={(e) => {
                const value = e.target.value;
                setFormData({ ...formData, name: value });
                clearApiError();
              }}
              onBlur={() => validator.showMessageFor("group_name")}
            />
            {validator.message("group_name", formData.name, "required", {
              className: "text-danger",
              messages: {
                required: "Collaboration Name field is required",
              },
            })}
            {formData.name.length > 100 && (
              <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                Collaboration name cannot exceed 100 characters.
              </div>
            )}
          </Box>

        {/* Member Search with validation */}
        {/* <Box sx={{ mb: 2 }}>
          <Autocomplete
            multiple
            id="group-members"
            options={options}
            getOptionLabel={(option) => `${option.username}`}
            loading={loading}
            value={members}
            onChange={handleMemberChange}
            inputValue={memberSearch}
            onInputChange={(event, newInputValue) => {
              setMemberSearch(newInputValue);
            }}
            onBlur={() => validator.showMessageFor("group_members")}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  key={option.id}
                  label={`${option.username}`}
                  {...getTagProps({ index })}
                  size="small"
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Collaboration Members"
                placeholder="Type at least 3 characters to search..."
                margin="normal"
                fullWidth
              />
            )}
          />
          {validator.message("group_members", formData.members, "required", {
            className: "text-danger",
            messages: {
              required: "Collaboration Members field is required",
            },
          })}
        </Box> */}

        {/* Actions */}
        <Box
          sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 3 }}
        >
          <Button
            onClick={onClose}
            sx={{
              textTransform: "none",
              color: "#6264A7",
              border: "1px solid #6264A7",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={isEditModel ? handleEdit : handleSave}
            sx={{
              textTransform: "none",
              color: "white",
              background: "#6264A7",
            }}
          >
            {isEditModel ? "Update" : "Create"}
          </Button>
        </Box>
      </Box>
    </Modal>
          {apiError && <ErrorPopup message={apiError} onClose={clearApiError} />}
    </>
  );
};

export default AddCollobrationModal;
